import { createAction } from '@reduxjs/toolkit';
import { featureKey } from '../..';

export const setDevSupportSettings = createAction<{ calculateLocally: boolean; skipPayment: boolean }>(
  featureKey + '/setDevSupportSettings'
);
